import _slicedToArray from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { defOp, NEW_OUT } from "./internal/codegen";
import { SET } from "./internal/templates";

var _defOp = defOp(SET, "o,a", undefined, "o", 1, NEW_OUT),
    _defOp2 = _slicedToArray(_defOp, 4),
    set = _defOp2[0],
    set2 = _defOp2[1],
    set3 = _defOp2[2],
    set4 = _defOp2[3];

export { set, set2, set3, set4 };